import React from "react";
import { useLang } from "@/context/LanguageContext";
import { Reveal, Eyebrow, Divider } from "@/components/site/primitives";
import { Logo } from "@/components/site/Logo";
import { Button } from "@/components/ui/button";

export const Closing = ({ onBook }) => {
  const { t } = useLang();
  return (
    <section className="relative py-32 sm:py-44 overflow-hidden" data-testid="closing-section">
      <div className="pointer-events-none absolute inset-0">
        {[...Array(20)].map((_, i) => (
          <span
            key={i}
            className="absolute rounded-full bg-gold/50 animate-twinkle"
            style={{ top: `${(i * 43) % 100}%`, left: `${(i * 71) % 100}%`, width: 2, height: 2, animationDelay: `${(i % 5) * 0.6}s` }}
          />
        ))}
      </div>
      <div className="relative max-w-3xl mx-auto px-5 sm:px-8 text-center">
        <Reveal>
          <Divider className="mb-8" />
          <Eyebrow>{t.closing.eyebrow}</Eyebrow>
          <h2 className="mt-6 font-display font-light italic text-sand text-4xl sm:text-6xl lg:text-7xl leading-[1.02]">
            {t.closing.title}
          </h2>
          <div className="mt-8 space-y-4 max-w-xl mx-auto">
            {t.closing.paragraphs.map((p, i) => (
              <p key={i} className="text-sand/70 text-base sm:text-lg leading-relaxed font-light">{p}</p>
            ))}
            <p className="pt-2 font-editorial italic text-gold text-2xl">{t.closing.emphasis}</p>
          </div>
          <Button
            onClick={onBook}
            className="mt-10 rounded-full bg-rust hover:bg-rust/90 text-cream h-12 px-9 font-body tracking-wide transition-transform hover:scale-[0.97]"
            data-testid="closing-book-button"
          >
            {t.closing.cta}
          </Button>
        </Reveal>
      </div>
    </section>
  );
};

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="relative border-t border-gold/15 bg-espresso/50" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 grid sm:grid-cols-[1.2fr_1fr] gap-10 items-start">
        <div>
          <div className="flex items-center gap-3">
            <Logo className="text-gold" size={40} />
            <span className="font-serifluxe text-sand tracking-[0.25em] uppercase text-lg">{t.brand}</span>
          </div>
          <p className="mt-5 text-sand/60 text-sm font-light max-w-sm leading-relaxed">{t.footer.tagline}</p>
        </div>
        <div className="sm:text-right">
          <a href="mailto:askmonia.tarot@gmail.com" className="text-gold hover:text-cream transition-colors font-editorial italic text-xl">
            askmonia.tarot@gmail.com
          </a>
          <p className="mt-6 text-sand/40 text-xs">© {new Date().getFullYear()} {t.brand}. {t.footer.rights}</p>
        </div>
      </div>
    </footer>
  );
};

export default Closing;
